<template>
  <div class="min-h-[900px]">
    <section
      class="flex flex-col items-center pt-16 pb-28 lg:pt-[102px] lg:pb-[193px]"
    >
      <div class="mx-auto min-w-[320px] max-w-[1010px] px-4">
        <h1 class="landing_h1 mb-4 text-center">
          <Translate translate-key="page_data.faq.h1" />
        </h1>
        <FaqInner />
      </div>
    </section>
  </div>
</template>
<script setup lang="ts">
definePageMeta({ layout: "public" });

import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import FaqInner from "~/features/faq/components/FaqInner.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t("page_data.faq.seo_title"),
  description: () => t("page_data.faq.seo_description"),
  ogTitle: () => t("page_data.faq.seo_title"),
  ogDescription: () => t("page_data.faq.seo_description"),
  ogImageAlt: () => t("index_page.image_alt_content"),
});
useHead(() => ({
  meta: [{ name: "keywords", content: t("page_data.faq.seo_keywords") }],
}));
</script>
